import type { Dispatch, SetStateAction } from "react"
import { createContext } from "react"

import type { FetchNextPageOptions } from "react-query"

import type { MRT_PaginationState } from "material-react-table"

import type { Label } from "../../../types/generated/api/Label"
import type { ListPredictionsOutput } from "../../../types/generated/api/ListPredictionsOutput"
import type { PaginatedListPredictionsList } from "../../../types/generated/api/PaginatedListPredictionsList"

export const DecisionsContext = createContext<{
  data: PaginatedListPredictionsList | undefined
  isFetching: boolean
  isLoading: boolean
  pagination: MRT_PaginationState
  setPagination?: Dispatch<SetStateAction<MRT_PaginationState>>
  filterObject: Record<PropertyKey, unknown>
  setFilterObject: Dispatch<SetStateAction<Record<PropertyKey, unknown>>>
  reviewLabel: "REVIEWED" | "REVOKED" | undefined
  setReviewLabel: React.Dispatch<React.SetStateAction<"REVIEWED" | "REVOKED" | undefined>>
  jointOutputFilter: string | undefined
  setJointOutputFilter: Dispatch<SetStateAction<string | undefined>>
  reasonFilter: string | undefined
  setReasonFilter: Dispatch<SetStateAction<string | undefined>>
  feedbackFilter: string | undefined
  setFeedbackFilter: Dispatch<SetStateAction<string | undefined>>
  isFetchingLabelsNextPage: boolean
  hasNextLabelsPage?: boolean
  fetchNextLabelsPage: (options?: FetchNextPageOptions) => void
  labels?: Label[]
  setLabelsSearchValue: Dispatch<SetStateAction<string | undefined>>
  selectedRow: ListPredictionsOutput | null
  setSelectedRow: Dispatch<SetStateAction<ListPredictionsOutput | null>>
}>({
  data: undefined,
  isFetching: false,
  isLoading: false,
  pagination: { pageIndex: 0, pageSize: 10 },
  setPagination: () => {
    // Default empty implementation for context default value
  },
  filterObject: {},
  setFilterObject: () => {
    // Default empty implementation for context default value
  },
  reviewLabel: undefined,
  setReviewLabel: () => {
    // Default empty implementation for context default value
  },
  jointOutputFilter: undefined,
  setJointOutputFilter: () => {
    // Default empty implementation for context default value
  },
  reasonFilter: undefined,
  setReasonFilter: () => {
    // Default empty implementation for context default value
  },
  feedbackFilter: undefined,
  setFeedbackFilter: () => {
    // Default empty implementation for context default value
  },
  fetchNextLabelsPage: () => {
    // Default empty implementation for context default value
  },
  labels: [],
  isFetchingLabelsNextPage: false,
  hasNextLabelsPage: undefined,
  setLabelsSearchValue: () => {
    // Default empty implementation for context default value
  },
  selectedRow: null,
  setSelectedRow: () => {
    // Default empty implementation for context default value
  },
})
